import React, { useState } from 'react';
import './Partenaire.css';
import axios from 'axios';

const PartenaireForm = () => {
  const [formData, setFormData] = useState({
    nom: '', prenom: '', email: '', telephone: '',
    pays: '', region: '', activite: '',
    partenariat: '', autrePartenariat: '',
    message: ''
  });

  const [popupMessage, setPopupMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const dataToSend = {
    ...formData,
    partenariat:
      formData.partenariat === 'Autre' && formData.autrePartenariat.trim()
        ? formData.autrePartenariat
        : formData.partenariat,
  };

  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/partenaire`, dataToSend);
    setPopupMessage('✅ Demande envoyée avec succès !');
    setShowPopup(true);
    setFormData({
      nom: '', prenom: '', email: '', telephone: '',
      pays: '', region: '', activite: '',
      partenariat: '', autrePartenariat: '',
      message: ''
    });
  } catch (error) {
    setPopupMessage("❌ Erreur lors de l'envoi.");
    setShowPopup(true);
    console.error(error);
  }
};

  return (
    <div className="partenaire-container">
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <p>{popupMessage}</p>
            <button onClick={() => setShowPopup(false)}>Fermer</button>
          </div>
        </div>
      )}

      <div className="partenaire-form-box">
        <h2>🤝 Devenez notre Partenaire</h2>
        <form className="partenaire-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input type="text" name="nom" placeholder="Nom *" value={formData.nom} onChange={handleChange} required />
            <input type="text" name="prenom" placeholder="Prénom(s) *" value={formData.prenom} onChange={handleChange} required />
          </div>

          <div className="input-group">
            <input type="email" name="email" placeholder="Email *" value={formData.email} onChange={handleChange} required />
            <input type="text" name="telephone" placeholder="Téléphone *" value={formData.telephone} onChange={handleChange} required />
          </div>

          <div className="input-group">
            <input type="text" name="pays" placeholder="Pays *" value={formData.pays} onChange={handleChange} required />
            <input type="text" name="region" placeholder="Région *" value={formData.region} onChange={handleChange} required />
          </div>

          <input type="text" name="activite" placeholder="Activité *" value={formData.activite} onChange={handleChange} required />

          <select name="partenariat" value={formData.partenariat} onChange={handleChange} required>
            <option value="">-- Partenariat * --</option>
            <option value="Culture d'innovation pour les entreprises à Madagascar">Culture d'innovation pour les entreprises à Madagascar</option>
            <option value="Transformation digitale">Transformation digitale</option>
            <option value="Développement de l'employabilité">Développement de l'employabilité</option>
            <option value="Voyage d'affaires aux USA et au Canada">Voyage d'affaires aux USA et au Canada</option>
            <option value="Autre">Autre à preciser</option>
          </select>

          {formData.partenariat === 'Autre' && (
            <input
              type="text"
              name="autrePartenariat"
              placeholder="Précisez votre partenariat"
              value={formData.autrePartenariat}
              onChange={handleChange}
              required
            />
          )}

          <textarea name="message" placeholder="Votre message" value={formData.message} onChange={handleChange} required />

          <button type="submit">✉️ Envoyer</button>
        </form>
      </div>
    </div>
  );
};

export default PartenaireForm;

